<template>
  <div class="brew-timeline">
    <h2>Timeline</h2>
    <div class="timeline-wrapper">
      <ul class="stream-names">
        <li v-if="loadingStreams"><BaseLoader :loading="loadingStreams"/></li>
        <li v-if="brewSessions" v-for="stream in streams">{{stream.name}}</li>
      </ul>
      <div class="brew-sessions">
        <ul v-if="brewSessions" class="brew-session timeline-names" :style="{ width: entryPeriod() + 'px'}">
          <li v-for="month in timelineMonths()" :style="{ left: month.offset + 'px' }">{{month.datetime | parseMonth }}</li>
        </ul>

        <BaseLoader :loading="loadingBrewSessions"/>
        <ul v-if="brewSessions" v-for="stream in streams" class="brew-session">
          <li  v-for="(brewSession) in recordsByStream(stream.id)"
              :title="brewSession.recipeName"
              :style="{ width: getBrewSessionAge(brewSession) + 'px', left: brewSession.offset + 'px' }">
            <router-link :to="{ name: 'recipe-show', params: { id: brewSession.recipeId }}">
              {{brewSession.recipeName}}</router-link>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
    import { HTTP } from '../lib/http';

    const DAY = 86400000;
    const DAY_PIXELS = 10;

    export default {
        name: "brew-timeline-component",
        data() {
            return {
                brewSessions: null,
                streams: null,
                errors: null,
                loadingBrewSessions: true,
                loadingStreams: true
            };
        },
        methods: {
            sortedBrewSessions() {
                return _(this.brewSessions)
                    .filter((sesh) => sesh.firstUpdate)
                    .sortBy((sesh) => sesh.firstUpdate.timestamp)
                    .value()
            },
            getBrewSessionAge(brew) {
               return ((brew.lastUpdate.timestamp - brew.firstUpdate.timestamp) / DAY) * DAY_PIXELS;
            },
            recordsByStream(streamId) {
                return _(this.timelineBrewSessions()).filter((brew) => brew.streamId === streamId).value();
            },
            firstEntryTime() {
                return new Date(_(this.sortedBrewSessions()).first().firstUpdate.timestamp)
            },
            lastEntryTime() {
                return new Date(_(this.sortedBrewSessions()).last().lastUpdate.timestamp)
            },
            entryPeriod() {
                let firstDate = this.firstEntryTime();
                let lastDate = this.lastEntryTime();
                let firsEntry = (new Date(firstDate.getFullYear(), firstDate.getMonth(), 1)).getTime();
                let lastEntry = (new Date(lastDate.getFullYear(), lastDate.getMonth(), this.daysInMonth(lastDate.getMonth(),lastDate.getFullYear()))).getTime();

                return (lastEntry - firsEntry) / DAY * DAY_PIXELS
            },
            daysInMonth(month, year) {
              return new Date(year, month, 0).getDate();
            },
            timelineBrewSessions() {
                let firstTimestamp = (new Date(this.firstEntryTime().getFullYear(), this.firstEntryTime().getMonth(), 1)).getTime();
                let daysBetween = 0;

                return _(this.sortedBrewSessions()).map(function (brewSession) {
                    daysBetween = (brewSession.firstUpdate.timestamp - firstTimestamp) / DAY;
                    brewSession.offset = daysBetween * DAY_PIXELS;
                    return brewSession;
                });
            },
            timelineMonths() {
                let firstentry = this.firstEntryTime();
                let lastDate = this.lastEntryTime();
                let months = [];
                let lastMonthTimestamp = new Date(lastDate.getFullYear(), lastDate.getMonth(), 1).getTime();
                let addon = 0;
                let firstDate = new Date(firstentry.getFullYear(), firstentry.getMonth(), 1);
                let newDate = firstDate;
                let daysPerMonth = 0;

                while (newDate.getTime() < lastMonthTimestamp) {
                    newDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + addon);
                    months.push({
                        datetime: newDate,
                        offset: daysPerMonth * DAY_PIXELS
                    });

                    daysPerMonth = daysPerMonth + this.daysInMonth(newDate.getMonth(), newDate.getFullYear());
                    addon++;
                }

                return months;
            },
            fetchBrewSession() {
                HTTP
                    .get('brew-sessions/')
                    .then(response => {
                        this.brewSessions = response.data.data;
                    })
                    .catch(err => {
                        this.errors = [err.response.data.message];
                    })
                    .then(() => {
                        this.loadingBrewSessions = false;
                    });
            },
            fetchStreams() {
                HTTP.get("streams")
                    .then(response => {
                        this.streams = response.data.data;
                    })
                    .catch(err => {
                        this.errors = [err.response.data.message];
                    })
                    .then(() => {
                        this.loadingStreams = false;
                    });
            },
        },
        mounted() {
            this.fetchBrewSession();
            this.fetchStreams()
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "/../assets/scss/_variablesx.scss";
  $block-margin: 5px;
  $block-height: 50px - ($block-margin * 2);
  $timeline-names-height: 20px;
  $day-width: 10px;

  .brew-timeline {
    margin-bottom: 1em;
    ul {
      padding: 0;
      margin: 0;
      list-style-type: none;

      li  {
        padding: 0;
        margin: 0;
      }
    }
    .timeline-wrapper {
      display: flex;

      .stream-names { flex-grow: 1; }
      .brew-sessions { flex-grow: 50; }
    }

    .stream-names {
      min-width: 100px;
      margin-top: $timeline-names-height + $block-margin * 2;

      li {
        height: $block-height;
        margin: $block-margin 0;
      }
      @media (max-width: 575.98px) {
        display: none;
      }
    }

    .brew-sessions {
      overflow-y: scroll;
      position: relative;

      .brew-session {
        position: relative;
        font-size: .8em;
        height: $block-height + $block-margin * 2;

        &::after {
          content: '|';
          opacity: 0;
        }

        li {
          display: inline-block;
          position: absolute;
          height: $block-height;
          margin: $block-margin 0;
          padding-top: $block-margin * 2;
          padding-left: $block-margin * 3;
          padding-right: $block-margin * 3;
          background-color: #e9ecef;
          border: 1px solid $white;
          border-radius: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .brew-session.timeline-names {
        height: $timeline-names-height;
        margin: 0;
        border-bottom: 2px solid $gray-400;
        position: absolute;

        & + .brew-session {
          margin-top: $block-margin * 4;
        }

        li {
          background: 0;
          height: $timeline-names-height;
          padding: 0;
          margin: 0;
          border: 0;

          &::before {
            content: '|';
            margin-right: 5px;
            position: relative;
            color: $gray-400;
            /*font-size: 2em;*/
            font-weight: bold;
            bottom: -10px;
          }
        }
      }
    }
  }
</style>
